export default "__VITE_ASSET__Bl5iJckH__"